import { render, staticRenderFns } from "./audit-point-record.vue?vue&type=template&id=7cffbc95&scoped=true"
import script from "./audit-point-record.vue?vue&type=script&lang=js"
export * from "./audit-point-record.vue?vue&type=script&lang=js"
import style0 from "./audit-point-record.vue?vue&type=style&index=0&id=7cffbc95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cffbc95",
  null
  
)

export default component.exports